import { z } from 'zod'
import { DATA_ROOM_FOLDER_NAME_MAX_LENGTH } from 'src/enviroment/constants/constants'

export const folderNameSchema = z
  .string()
  .trim()
  .min(1, { message: 'Folder name is required' })
  .max(DATA_ROOM_FOLDER_NAME_MAX_LENGTH, {
    message: `Folder name cannot exceed ${DATA_ROOM_FOLDER_NAME_MAX_LENGTH} characters`,
  })
  .refine((val) => !/[/\\]/.test(val), { message: 'Folder name must not contain slashes' })
